interface SubcategorySectionProps {
  subcategory: {
    name: string;
    places: Array<{
      name: string;
      likes: number;
      location: string;
      distance: string;
      image: string;
      iconBg?: string;
    }>;
  };
  styles: {
    containerPadding: string;
    itemPadding: string;
    imageSize: string;
    fontSize: string;
    iconSize: string;
    gap: string;
  };
  variant?: string;
}

export function SubcategorySection({
  subcategory,
  styles,
  variant = "standard",
}: SubcategorySectionProps) {
  const variantStyles = variant === "special" ? "bg-gray-50" : "";

  return (
    <div className={`mb-8 ${styles.containerPadding} ${variantStyles}`}>
      <h2 className={`font-semibold mb-4 text-gray-900 ${styles.fontSize}`}>
        {subcategory.name}
      </h2>
      <div
        className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 ${styles.gap}`}
      >
        {subcategory.places.map((place, index) => (
          <div
            key={index}
            className={`bg-white rounded-lg shadow-sm overflow-hidden ${styles.itemPadding}`}
          >
            <img
              src={place.image}
              alt={place.name}
              className={`w-full object-cover ${styles.imageSize}`}
            />
            <div className={styles.itemPadding}>
              <h3 className={`font-medium ${styles.fontSize}`}>{place.name}</h3>
              <p className="text-gray-600 text-sm">{place.location}</p>
              <div className="flex items-center mt-2">
                <span className="text-yellow-500">★</span>
                <span className="ml-1 text-sm">{place.likes} likes</span>
                <span className="ml-2 text-sm text-gray-500">
                  {place.distance}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
